
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erpcige",
      function () {
        return require("private-next-pages/erpcige/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erpcige"])
      });
    }
  